import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3a21f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Administrare articole")
const _hoisted_6 = { style: {"margin-left":"auto"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Adauga articol nou! ")
const _hoisted_8 = {
  key: 0,
  class: "dashboard__document__section app__border__bottom"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"dashboard__product__details\" data-v-a3a21f3a><span class=\"app__label--small\" data-v-a3a21f3a>Cod Articol</span><span class=\"app__label--small\" data-v-a3a21f3a>Categorie</span><span class=\"app__label--small\" data-v-a3a21f3a>Caracteristici</span><span class=\"app__label--small\" data-v-a3a21f3a>Unitati Masura</span><span class=\"app__label--small\" data-v-a3a21f3a>Vizibil la Client</span></div><div class=\"dashboard__document__icons\" data-v-a3a21f3a></div>", 2)
const _hoisted_11 = [
  _hoisted_9
]
const _hoisted_12 = { class: "dashboard__product__details" }
const _hoisted_13 = {
  key: 0,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_14 = { class: "app__color--label" }
const _hoisted_15 = {
  key: 1,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_16 = { class: "app__property--small" }
const _hoisted_17 = {
  key: 2,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_18 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { key: 6 }
const _hoisted_26 = {
  key: 3,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_27 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"} }
const _hoisted_28 = { class: "app__property--small" }
const _hoisted_29 = { class: "app__property--small" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_32 = { class: "dashboard__document__icons" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Editeaza articolul ")
const _hoisted_34 = { class: "q-pa-lg flex flex-center" }
const _hoisted_35 = {
  key: 1,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_36 = {
  key: 2,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 100px)","top":"10px"}
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditArticle = _resolveComponent("EditArticle")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "qr_code",
                style: {"font-size":"2rem","top":"-3px"},
                color: "primary"
              }),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_input, {
          "bottom-slots": "",
          debounce: "300",
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterText) = $event)),
          dense: _ctx.dense
        }, {
          append: _withCtx(() => [
            (_ctx.filterText !== '')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterText = '')),
                  class: "cursor-pointer"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["modelValue", "dense"])
      ]),
      _withDirectives(_createVNode(_component_q_btn, {
        square: "",
        color: "blue",
        icon: "add",
        class: "article--add--btn",
        onClick: _ctx.onOpenFormAddNewArticle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, {
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, 1==2]
      ])
    ]),
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrArticles, (article) => {
      return (_openBlock(), _createElementBlock("div", {
        key: article.appid,
        class: "dashboard__document__section app__border__bottom"
      }, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Cod Articol:"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_14, _toDisplayString(article.code), 1),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Categorie:"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_16, _toDisplayString(article.lantHierarchyCategories), 1),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Caracteristici:"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_18, [
            (article.sizeLength)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Lungime " + _toDisplayString(article.sizeLength) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeWidth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Latime " + _toDisplayString(article.sizeWidth) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeThickness)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Grosime " + _toDisplayString(article.sizeThickness) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeDiameter)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Diametru " + _toDisplayString(article.sizeDiameter) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeHeight)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Inaltime " + _toDisplayString(article.sizeHeight) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeAlloy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Aliaj " + _toDisplayString(article.sizeAlloy), 1))
              : _createCommentVNode("", true),
            (article.sizeType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(article.sizeType), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Unitati Masura:"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(article.um1), 1),
            _createElementVNode("span", _hoisted_29, [
              _createTextVNode(_toDisplayString(article.um2) + " ", 1),
              (article.um2 && article.um2.length>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "(" + _toDisplayString(article.um1ToUm2) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_q_checkbox, {
              modelValue: article.isActive,
              "onUpdate:modelValue": [($event: any) => ((article.isActive) = $event), ($event: any) => (_ctx.changeStatus(article))],
              label: _ctx.$q.platform.is.mobile?'vizibil':'',
              "true-value": "y",
              "false-value": "n"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  color: "primary",
                  icon: "edit",
                  label: "Edit",
                  onClick: ($event: any) => (_ctx.openProductForEditing(article)),
                  size: "xs",
                  style: {"max-height":"1rem","margin-left":"2rem"}
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          (_ctx.$q.platform.is.desktop)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "edit",
                style: {"color":"#F7C325","font-size":"1.5rem","cursor":"pointer"},
                onClick: ($event: any) => (_ctx.openProductForEditing(article))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, {
                    "transition-show": "scale",
                    "transition-hide": "scale",
                    anchor: "center left",
                    self: "center right",
                    offset: [10, 10]
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (1==2)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "delete_forever",
                style: {"color":"red","font-size":"1.5rem","cursor":"pointer"}
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_34, [
      _createVNode(_component_q_pagination, {
        modelValue: _ctx.currentPageNumber,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPageNumber) = $event)),
        max: _ctx.maxPagesNumber,
        input: "",
        onInput: _ctx.inputPaginator
      }, null, 8, ["modelValue", "max", "onInput"])
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isShoDialogEditArticle,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShoDialogEditArticle) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { style: {"min-height":"40px"} }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      name: "arrow_back_ios",
                      class: "app__arrow--back"
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Editare articol"))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Editare articol"))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 3,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      dense: "",
                      flat: "",
                      icon: "close",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"85vh"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditArticle, {
                      pid: _ctx.selectedPidArticle,
                      closeHandler: _ctx.closeFormEditArticle
                    }, null, 8, ["pid", "closeHandler"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}